module.exports = __webpack_public_path__ + "static/assets/88fcfaa6843bdeb74dfd52952c6e70b2.png";